"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.viewCustomerInvoices = exports.validateResetKey = exports.updateResumeUrl = exports.updateProfileDetails = exports.updateMarketingPreferences = exports.updateEmployeeDetails = exports.updateContactPreferences = exports.updateCompanyUserQuestion = exports.updateCompanyDetails = exports.updateCDHCard = exports.updateBusinessQuestions = exports.updateBookingAllowances = exports.updateBookingAlerts = exports.updateAppContactDetails = exports.updateAppCompanyDetails = exports.submitRegistration = exports.submitApplication = exports.shareApplication = exports.sendActivationEmail = exports.saveCard = exports.resetPassword = exports.resetMemorableWord = exports.resendActivationEmail = exports.removeParticipant = exports.registrationStepTwo = exports.initializePayApplication = exports.forgotPassword = exports.directDebit = exports.deletePayAppCard = exports.deleteCompanyUserQuestion = exports.deleteCDHCard = exports.deleteApplication = exports.createCompanyUserQuestion = exports.businessTetherLogin = exports.businessTether = exports.bulkUploadEmployees = exports.authenticateRegistration = exports.approveRejectEmployee = exports.addPayAppCard = exports.addNewEmployee = exports.addCardPIBAMutation = exports.activatePibaCard = exports.InnBRegistrationStepOne = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _api = require("@whitbread-eos/api");
var _getters = require("../getters");
var _gql = require("../gql");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var findError = (code, errors) => {
  return errors.some(error => JSON.parse(error.message).code === code);
};
var submitApplication = exports.submitApplication = function () {
  var _ref = (0, _asyncToGenerator2.default)(function* (applicationGuid, applicationId, scheme, hostedPageGuid, registrationQuestion, registrationAnswer, termsAndConditionAccepted, isDirectDebit, token) {
    return yield (0, _gql.executeGraphQLMutation)(_api.submitApplicationMutation, {
      submitApplicationRequest: {
        applicationGuid,
        applicationId,
        scheme,
        hostedPageGuid: isDirectDebit ? hostedPageGuid : null,
        registrationQuestion,
        registrationAnswer,
        termsAndConditionAccepted: termsAndConditionAccepted ? 'Y' : 'n',
        isDirectDebit
      }
    }, result => {
      var _result$data;
      var response = result === null || result === void 0 || (_result$data = result.data) === null || _result$data === void 0 || (_result$data = _result$data.submitApplicationV1) === null || _result$data === void 0 ? void 0 : _result$data.message;
      if (response) {
        return {
          status: _api.requestStatus.success
        };
      }
      return {
        status: _api.requestStatus.fail,
        errors: result === null || result === void 0 ? void 0 : result.errors
      };
    }, token);
  });
  return function submitApplication(_x, _x2, _x3, _x4, _x5, _x6, _x7, _x8, _x9) {
    return _ref.apply(this, arguments);
  };
}();
var addPayAppCard = exports.addPayAppCard = function () {
  var _ref2 = (0, _asyncToGenerator2.default)(function* (applicationGuid, applicationId, scheme, cardDetails, token, employeeId) {
    return yield (0, _gql.executeGraphQLMutation)((0, _api.addPayAppCardMutation)(), {
      addApplicationCardCriteria: {
        applicationGuid,
        applicationId,
        employeeId,
        scheme,
        cardDetails
      }
    }, result => {
      var _result$data2;
      var response = result === null || result === void 0 || (_result$data2 = result.data) === null || _result$data2 === void 0 || (_result$data2 = _result$data2.addApplicationCard) === null || _result$data2 === void 0 ? void 0 : _result$data2.cardGuid;
      if (response) {
        return {
          status: _api.requestStatus.success,
          cardGuid: response
        };
      }
      return {
        status: _api.requestStatus.fail,
        errors: result === null || result === void 0 ? void 0 : result.errors
      };
    }, token);
  });
  return function addPayAppCard(_x10, _x11, _x12, _x13, _x14, _x15) {
    return _ref2.apply(this, arguments);
  };
}();
var deletePayAppCard = exports.deletePayAppCard = function () {
  var _ref3 = (0, _asyncToGenerator2.default)(function* (applicationGuid, applicationId, cardGuid, token) {
    return yield (0, _gql.executeGraphQLMutation)((0, _api.deletePayAppCardMutation)(), {
      deleteApplicationCardRequest: {
        applicationGuid,
        applicationId,
        cardGuid
      }
    }, result => {
      var _result$data3;
      var response = result === null || result === void 0 || (_result$data3 = result.data) === null || _result$data3 === void 0 ? void 0 : _result$data3.deleteApplicationCard;
      if (response === '') {
        return {
          status: _api.requestStatus.success
        };
      }
      return {
        status: _api.requestStatus.fail,
        errors: result === null || result === void 0 ? void 0 : result.errors
      };
    }, token);
  });
  return function deletePayAppCard(_x16, _x17, _x18, _x19) {
    return _ref3.apply(this, arguments);
  };
}();
var activatePibaCard = exports.activatePibaCard = function () {
  var _ref4 = (0, _asyncToGenerator2.default)(function* (tetheredUserId, cardId, countryCode, token) {
    return yield (0, _gql.executeGraphQLMutation)((0, _api.activatePibaCardMutation)(), {
      tetheredUserId,
      cardId,
      countryCode
    }, result => {
      var _result$data4;
      var response = result === null || result === void 0 || (_result$data4 = result.data) === null || _result$data4 === void 0 ? void 0 : _result$data4.activateInnBPIBACard;
      if (response) {
        return {
          status: _api.requestStatus.success
        };
      }
      return {
        status: _api.requestStatus.fail,
        error: _api.requestErrors.generic
      };
    }, token);
  });
  return function activatePibaCard(_x20, _x21, _x22, _x23) {
    return _ref4.apply(this, arguments);
  };
}();
var addNewEmployee = exports.addNewEmployee = function () {
  var _ref5 = (0, _asyncToGenerator2.default)(function* (companyId, languageCode, data, token) {
    return yield (0, _gql.executeGraphQLMutation)((0, _api.addEmployee)(), {
      companyId,
      languageCode,
      employee: data
    }, result => {
      var _result$data5;
      var successResponse = result === null || result === void 0 || (_result$data5 = result.data) === null || _result$data5 === void 0 ? void 0 : _result$data5.addEmployee;
      if (successResponse) {
        var splitResponse = successResponse.split('/');
        var employeeId = splitResponse[splitResponse.length - 1];
        return {
          status: _api.requestStatus.success,
          employeeId
        };
      }
      return {
        status: _api.requestStatus.fail,
        error: _api.requestErrors.generic
      };
    }, token);
  });
  return function addNewEmployee(_x24, _x25, _x26, _x27) {
    return _ref5.apply(this, arguments);
  };
}();
var addCardPIBAMutation = exports.addCardPIBAMutation = function () {
  var _ref6 = (0, _asyncToGenerator2.default)(function* (data, token) {
    return yield (0, _gql.executeGraphQLMutation)((0, _api.addCardPIBA)(), data, result => {
      var _result$data6;
      var response = result === null || result === void 0 || (_result$data6 = result.data) === null || _result$data6 === void 0 ? void 0 : _result$data6.addInnBPIBACard;
      if (response !== null && response !== void 0 && response.cardNumber) {
        return {
          status: _api.requestStatus.success,
          data: response
        };
      }
      return {
        status: _api.requestStatus.fail,
        error: _api.requestErrors.generic
      };
    }, token);
  });
  return function addCardPIBAMutation(_x28, _x29) {
    return _ref6.apply(this, arguments);
  };
}();
var updateEmployeeDetails = exports.updateEmployeeDetails = function () {
  var _ref7 = (0, _asyncToGenerator2.default)(function* (companyId, employeeId, languageCode, data, token, activationKey) {
    return yield (0, _gql.executeGraphQLMutation)((0, _api.updateEmployee)(), {
      companyId,
      employeeId,
      languageCode,
      updateEmployeeCriteria: data,
      activationKey
    }, result => {
      var _result$errors, _result$data7;
      var genericError = {
        status: _api.requestStatus.fail,
        error: _api.requestErrors.generic
      };
      if ((result === null || result === void 0 || (_result$errors = result.errors) === null || _result$errors === void 0 ? void 0 : _result$errors.length) > 0) {
        var lastTMError = findError(_api.requestErrors.lastTravelManager, result.errors);
        if (lastTMError) {
          return _objectSpread(_objectSpread({}, genericError), {}, {
            error: _api.requestErrors.lastTravelManager
          });
        }
        return genericError;
      }
      if ((result === null || result === void 0 || (_result$data7 = result.data) === null || _result$data7 === void 0 ? void 0 : _result$data7.updateEmployee) === '') {
        return {
          status: _api.requestStatus.success
        };
      }
      return genericError;
    }, token);
  });
  return function updateEmployeeDetails(_x30, _x31, _x32, _x33, _x34, _x35) {
    return _ref7.apply(this, arguments);
  };
}();
var updateProfileDetails = exports.updateProfileDetails = function () {
  var _ref8 = (0, _asyncToGenerator2.default)(function* (customerId, data, token) {
    return yield (0, _gql.executeGraphQLMutation)((0, _api.updateProfileDetailsQuery)(), {
      customerId,
      business: true,
      payload: data,
      innBusiness: true
    }, result => {
      var _result$errors2, _result$data8;
      var genericError = {
        status: _api.requestStatus.fail,
        error: _api.requestErrors.generic
      };
      if ((result === null || result === void 0 || (_result$errors2 = result.errors) === null || _result$errors2 === void 0 ? void 0 : _result$errors2.length) > 0) {
        var currentPasswordNotMatch = findError(_api.requestErrors.currentPasswordNotMatch, result.errors);
        if (currentPasswordNotMatch) {
          return _objectSpread(_objectSpread({}, genericError), {}, {
            error: _api.requestErrors.currentPasswordNotMatch
          });
        }
        return genericError;
      }
      if (result !== null && result !== void 0 && (_result$data8 = result.data) !== null && _result$data8 !== void 0 && _result$data8.updateProfileDetails.success) {
        return {
          status: _api.requestStatus.success
        };
      }
      return genericError;
    }, token);
  });
  return function updateProfileDetails(_x36, _x37, _x38) {
    return _ref8.apply(this, arguments);
  };
}();
var updateCompanyDetails = exports.updateCompanyDetails = function () {
  var _ref9 = (0, _asyncToGenerator2.default)(function* (companyId, data, token) {
    return yield (0, _gql.executeGraphQLMutation)((0, _api.updateCompanyDetailsQuery)(), {
      companyId,
      companySummary: data
    }, result => {
      var _result$data9;
      var genericError = {
        status: _api.requestStatus.fail,
        error: _api.requestErrors.generic
      };
      if ((result === null || result === void 0 || (_result$data9 = result.data) === null || _result$data9 === void 0 ? void 0 : _result$data9.updateCompanyDetails) === '') {
        return {
          status: _api.requestStatus.success
        };
      }
      return genericError;
    }, token);
  });
  return function updateCompanyDetails(_x39, _x40, _x41) {
    return _ref9.apply(this, arguments);
  };
}();
var updateBusinessQuestions = exports.updateBusinessQuestions = function () {
  var _ref10 = (0, _asyncToGenerator2.default)(function* (companyId, questionId, data, token) {
    return yield (0, _gql.executeGraphQLMutation)((0, _api.updateBusinessQuestionsQuery)(), {
      companyId,
      questionId,
      userQuestion: data
    }, result => {
      var _result$data10;
      var genericError = {
        status: _api.requestStatus.fail,
        error: _api.requestErrors.generic
      };
      if ((result === null || result === void 0 || (_result$data10 = result.data) === null || _result$data10 === void 0 ? void 0 : _result$data10.updateBusinessQuestions) === '') {
        return {
          status: _api.requestStatus.success
        };
      }
      return genericError;
    }, token);
  });
  return function updateBusinessQuestions(_x42, _x43, _x44, _x45) {
    return _ref10.apply(this, arguments);
  };
}();
var updateCompanyUserQuestion = exports.updateCompanyUserQuestion = function () {
  var _ref11 = (0, _asyncToGenerator2.default)(function* (companyId, questionId, data, token) {
    return yield (0, _gql.executeGraphQLMutation)((0, _api.updateCompanyUserQuestionQuery)(), {
      companyId,
      questionId,
      userQuestion: data
    }, result => {
      var _result$data11;
      var genericError = {
        status: _api.requestStatus.fail,
        error: _api.requestErrors.generic
      };
      if ((result === null || result === void 0 || (_result$data11 = result.data) === null || _result$data11 === void 0 ? void 0 : _result$data11.updateCompanyUserQuestion) === '') {
        return {
          status: _api.requestStatus.success
        };
      }
      return genericError;
    }, token);
  });
  return function updateCompanyUserQuestion(_x46, _x47, _x48, _x49) {
    return _ref11.apply(this, arguments);
  };
}();
var updateBookingAllowances = exports.updateBookingAllowances = function () {
  var _ref12 = (0, _asyncToGenerator2.default)(function* (companyId, data, token) {
    return yield (0, _gql.executeGraphQLMutation)((0, _api.updateBookingAllowancesQuery)(), {
      companyId,
      bookingAllowances: data
    }, result => {
      var _result$data12;
      var genericError = {
        status: _api.requestStatus.fail,
        error: _api.requestErrors.generic
      };
      if ((result === null || result === void 0 || (_result$data12 = result.data) === null || _result$data12 === void 0 ? void 0 : _result$data12.updateBookingAllowances) === '') {
        return {
          status: _api.requestStatus.success
        };
      }
      return genericError;
    }, token);
  });
  return function updateBookingAllowances(_x50, _x51, _x52) {
    return _ref12.apply(this, arguments);
  };
}();
var createCompanyUserQuestion = exports.createCompanyUserQuestion = function () {
  var _ref13 = (0, _asyncToGenerator2.default)(function* (companyId, data, token) {
    return yield (0, _gql.executeGraphQLMutation)((0, _api.createCompanyUserQuestionQuery)(), {
      companyId,
      userQuestion: data
    }, result => {
      var _result$data13;
      var genericError = {
        status: _api.requestStatus.fail,
        error: _api.requestErrors.generic
      };
      if ((result === null || result === void 0 || (_result$data13 = result.data) === null || _result$data13 === void 0 ? void 0 : _result$data13.createCompanyUserQuestion) === '') {
        return {
          status: _api.requestStatus.success
        };
      }
      return genericError;
    }, token);
  });
  return function createCompanyUserQuestion(_x53, _x54, _x55) {
    return _ref13.apply(this, arguments);
  };
}();
var deleteCompanyUserQuestion = exports.deleteCompanyUserQuestion = function () {
  var _ref14 = (0, _asyncToGenerator2.default)(function* (companyId, questionId, token) {
    return yield (0, _gql.executeGraphQLMutation)((0, _api.deleteCompanyCustomQuestionQuery)(), {
      companyId,
      questionId
    }, result => {
      var _result$data14;
      var genericError = {
        status: _api.requestStatus.fail,
        error: _api.requestErrors.generic
      };
      if ((result === null || result === void 0 || (_result$data14 = result.data) === null || _result$data14 === void 0 ? void 0 : _result$data14.deleteCustomQuestion) === '') {
        return {
          status: _api.requestStatus.success
        };
      }
      return genericError;
    }, token);
  });
  return function deleteCompanyUserQuestion(_x56, _x57, _x58) {
    return _ref14.apply(this, arguments);
  };
}();
var deleteCDHCard = exports.deleteCDHCard = function () {
  var _ref15 = (0, _asyncToGenerator2.default)(function* (companyId, cardId, token) {
    return yield (0, _gql.executeGraphQLMutation)((0, _api.deleteCardCDHMutation)(), {
      companyId,
      cardId
    }, result => {
      var _result$data15;
      var genericError = {
        status: _api.requestStatus.fail,
        error: _api.requestErrors.generic
      };
      if ((result === null || result === void 0 || (_result$data15 = result.data) === null || _result$data15 === void 0 ? void 0 : _result$data15.deleteCompanyCard) === '') {
        return {
          status: _api.requestStatus.success
        };
      }
      return genericError;
    }, token);
  });
  return function deleteCDHCard(_x59, _x60, _x61) {
    return _ref15.apply(this, arguments);
  };
}();
var businessTetherLogin = exports.businessTetherLogin = function () {
  var _ref16 = (0, _asyncToGenerator2.default)(function* (token, tetheredGuid, scheme) {
    return yield (0, _gql.executeGraphQLMutation)(_api.BUSINESS_TETHER_LOGIN, {
      loginCriteria: {
        guid: tetheredGuid,
        scheme: scheme
      }
    }, result => {
      var _result$data16;
      return result === null || result === void 0 || (_result$data16 = result.data) === null || _result$data16 === void 0 ? void 0 : _result$data16.businessTetherLogin;
    }, token);
  });
  return function businessTetherLogin(_x62, _x63, _x64) {
    return _ref16.apply(this, arguments);
  };
}();
var businessTether = exports.businessTether = function () {
  var _ref17 = (0, _asyncToGenerator2.default)(function* (linkCode, linkId, memorableWord, saveInCdh, token) {
    return yield (0, _gql.executeGraphQLMutation)(_api.businessTetherQuery, {
      linkCode: linkCode,
      linkId: linkId,
      memorableWord: memorableWord,
      saveInCdh: saveInCdh
    }, result => {
      var _result$data17;
      return result === null || result === void 0 || (_result$data17 = result.data) === null || _result$data17 === void 0 ? void 0 : _result$data17.businessTether;
    }, token);
  });
  return function businessTether(_x65, _x66, _x67, _x68, _x69) {
    return _ref17.apply(this, arguments);
  };
}();
var sendActivationEmail = exports.sendActivationEmail = function () {
  var _ref18 = (0, _asyncToGenerator2.default)(function* (token, companyId, languageCode, emailAddress, centralCardId) {
    return yield (0, _gql.executeGraphQLMutation)(_api.SEND_ACTIVATION_EMAIL, {
      companyId,
      languageCode,
      sendActivationEmailCriteria: {
        emailAddress,
        centralCardId
      }
    }, result => {
      var _result$data18;
      return result === null || result === void 0 || (_result$data18 = result.data) === null || _result$data18 === void 0 ? void 0 : _result$data18.sendActivationEmail;
    }, token);
  });
  return function sendActivationEmail(_x70, _x71, _x72, _x73, _x74) {
    return _ref18.apply(this, arguments);
  };
}();
var bulkUploadEmployees = exports.bulkUploadEmployees = function () {
  var _ref19 = (0, _asyncToGenerator2.default)(function* (token, companyId, file, locale) {
    try {
      var data = new FormData();
      data.append('upFile', file);
      var res = yield fetch("".concat(process.env.NEXT_PUBLIC_REST_API, "/companies/").concat(companyId, "/employees/bulk?innBusiness=true"), {
        method: 'POST',
        headers: {
          Origin: process.env.NEXT_PUBLIC_ASSETS_URL_WITHOUT_BASIC,
          Authorization: "Bearer ".concat(token),
          Language: locale === _api.LOCALES.EN ? 'en' : 'de'
        },
        cache: 'no-cache',
        body: data
      });
      if (!res.ok) {
        return null;
      }
      return true;
    } catch (error) {
      return null;
    }
  });
  return function bulkUploadEmployees(_x75, _x76, _x77, _x78) {
    return _ref19.apply(this, arguments);
  };
}();
var updateContactPreferences = exports.updateContactPreferences = function () {
  var _ref20 = (0, _asyncToGenerator2.default)(function* (email, token, locale, preferences) {
    try {
      var _preferences$optIn, _preferences$secondPa, _preferences$thirdPar, _response$data;
      var response = yield (0, _gql.executeGraphQLMutation)(_api.UPDATE_CONTACT_PREFERENCES, {
        contactType: 'email',
        contactValue: email,
        request: {
          brandCodes: ['PINN'],
          doubleOptIn: locale === _api.LOCALES.DE,
          customer: {
            language: locale === 'en' ? 'en' : 'de',
            countryOfResidence: locale === 'en' ? 'GB' : 'DE',
            firstName: '',
            lastName: '',
            title: '',
            userId: ''
          },
          optIn: (_preferences$optIn = preferences.optIn) !== null && _preferences$optIn !== void 0 ? _preferences$optIn : false,
          secondPartyOptIn: (_preferences$secondPa = preferences.secondPartyOptIn) !== null && _preferences$secondPa !== void 0 ? _preferences$secondPa : false,
          thirdPartyVendorsOptIn: (_preferences$thirdPar = preferences.thirdPartyVendorsOptIn) !== null && _preferences$thirdPar !== void 0 ? _preferences$thirdPar : false,
          sourceDetails: {
            channel: 'BB',
            journey: 'PERMISSIONCENTRE',
            locale: locale === 'en' ? 'UK' : 'DE'
          }
        }
      }, result => result, token);
      if ((response === null || response === void 0 || (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.updateContactPreferences) === '') {
        return {
          status: _api.requestStatus.success
        };
      }
      if (response !== null && response !== void 0 && response.errors) {
        return {
          status: _api.requestStatus.fail,
          error: _api.requestErrors.generic
        };
      }
      return {
        status: _api.requestStatus.fail,
        error: _api.requestErrors.generic
      };
    } catch (error) {
      return {
        status: _api.requestStatus.fail,
        error: _api.requestErrors.generic
      };
    }
  });
  return function updateContactPreferences(_x79, _x80, _x81, _x82) {
    return _ref20.apply(this, arguments);
  };
}();
var saveCard = exports.saveCard = function () {
  var _ref22 = (0, _asyncToGenerator2.default)(function* (_ref21) {
    var {
      token,
      profileDetails,
      onSuccess,
      onError,
      t,
      isPiba = false,
      language,
      memorableWord,
      cnpEnabled = false,
      isPreferenceCard,
      cardLabel,
      cardId = ''
    } = _ref21;
    try {
      var _profileDetails$conta;
      var requestId = (0, _getters.getRandomTracingId)();
      var address = (profileDetails === null || profileDetails === void 0 || (_profileDetails$conta = profileDetails.contactDetail) === null || _profileDetails$conta === void 0 ? void 0 : _profileDetails$conta.address) || {};
      var baseInitiateSaveCardRequest = {
        requestId,
        cardDetails: _objectSpread({
          cardLabel: cardLabel !== null && cardLabel !== void 0 ? cardLabel : undefined,
          cardType: isPiba ? 'PIBA' : 'CARD',
          business: true,
          cardId: isPreferenceCard ? '1' : cardId,
          cnpRequired: cnpEnabled,
          personalCard: isPreferenceCard
        }, isPiba && memorableWord ? {
          memorableWord
        } : {}),
        billingAddress: {
          line1: address.line1 || '',
          line2: address.line2 || '',
          line3: address.line3 || '',
          line4: address.line4 || '',
          line5: address.line5 || '',
          countryCode: address.countryCode || 'GB',
          postCode: address.postCode || '',
          companyName: address.companyName || '',
          type: address.type || 'BUSINESS'
        },
        environment: process.env.NODE_ENV === 'development' ? "https://".concat(process.env.NEXT_PUBLIC_ASSETS_URL) : window.location.origin,
        language
      };
      var executeQuery = function () {
        var _ref23 = (0, _asyncToGenerator2.default)(function* (variables) {
          return (0, _gql.executeGraphQLMutation)(_api.SAVE_CARD_MUTATION, variables, data => {
            var _data$errors, _data$data;
            if ((data === null || data === void 0 || (_data$errors = data.errors) === null || _data$errors === void 0 ? void 0 : _data$errors.length) > 0) return null;
            return data === null || data === void 0 || (_data$data = data.data) === null || _data$data === void 0 ? void 0 : _data$data.saveCard;
          }, token);
        });
        return function executeQuery(_x84) {
          return _ref23.apply(this, arguments);
        };
      }();
      var result = yield executeQuery({
        initiateSaveCardRequest: baseInitiateSaveCardRequest
      });
      if (!result) {
        throw new Error(t('Failed to save card'));
      }
      onSuccess(result);
      return result;
    } catch (error) {
      onError(error.message || 'Error saving card');
      throw error;
    }
  });
  return function saveCard(_x83) {
    return _ref22.apply(this, arguments);
  };
}();
var resetMemorableWord = exports.resetMemorableWord = function () {
  var _ref24 = (0, _asyncToGenerator2.default)(function* (tetheredUserGuid, memorableWord, token, scheme) {
    return yield (0, _gql.executeGraphQLMutation)((0, _api.resetMemorableWordQuery)(), {
      tetheredUserGuid,
      memorableWord,
      scheme
    }, result => {
      var _result$data19;
      var genericError = {
        status: _api.requestStatus.fail,
        error: _api.requestErrors.generic
      };
      if ((result === null || result === void 0 || (_result$data19 = result.data) === null || _result$data19 === void 0 || (_result$data19 = _result$data19.resetMemorableWord) === null || _result$data19 === void 0 ? void 0 : _result$data19.resultCode) === 'OK') {
        return {
          status: _api.requestStatus.success
        };
      }
      return genericError;
    }, token);
  });
  return function resetMemorableWord(_x85, _x86, _x87, _x88) {
    return _ref24.apply(this, arguments);
  };
}();
var initializePayApplication = exports.initializePayApplication = function () {
  var _ref25 = (0, _asyncToGenerator2.default)(function* (token, email, scheme) {
    return yield (0, _gql.executeGraphQLMutation)((0, _api.initializeApplicationQuery)(), {
      email,
      scheme
    }, result => {
      var _result$data20;
      return result === null || result === void 0 || (_result$data20 = result.data) === null || _result$data20 === void 0 ? void 0 : _result$data20.initializeApplication;
    }, token);
  });
  return function initializePayApplication(_x89, _x90, _x91) {
    return _ref25.apply(this, arguments);
  };
}();
var deleteApplication = exports.deleteApplication = function () {
  var _ref26 = (0, _asyncToGenerator2.default)(function* (applicationId, applicationGuid, scheme, token) {
    return yield (0, _gql.executeGraphQLMutation)((0, _api.deleteApplicationQuery)(), {
      applicationId,
      applicationGuid,
      scheme
    }, result => result.data.deleteApplication, token);
  });
  return function deleteApplication(_x92, _x93, _x94, _x95) {
    return _ref26.apply(this, arguments);
  };
}();
var updateAppContactDetails = exports.updateAppContactDetails = function () {
  var _ref27 = (0, _asyncToGenerator2.default)(function* (token, criteria) {
    return yield (0, _gql.executeGraphQLMutation)((0, _api.updateAppContactDetailsQuery)(), {
      updateAppContactDetailsCriteria: criteria
    }, result => {
      var _result$data21;
      var response = result === null || result === void 0 || (_result$data21 = result.data) === null || _result$data21 === void 0 ? void 0 : _result$data21.updateAppContactDetails;
      if (response) {
        return {
          status: _api.requestStatus.success
        };
      }
      return {
        status: _api.requestStatus.fail,
        errors: result === null || result === void 0 ? void 0 : result.errors
      };
    }, token);
  });
  return function updateAppContactDetails(_x96, _x97) {
    return _ref27.apply(this, arguments);
  };
}();
var updateAppCompanyDetails = exports.updateAppCompanyDetails = function () {
  var _ref28 = (0, _asyncToGenerator2.default)(function* (token, criteria) {
    return yield (0, _gql.executeGraphQLMutation)((0, _api.updateAppCompanyDetailsQuery)(), {
      updateAppCompanyDetailsCriteria: criteria
    }, result => {
      var _result$data22;
      var response = result === null || result === void 0 || (_result$data22 = result.data) === null || _result$data22 === void 0 ? void 0 : _result$data22.updateAppCompanyDetails;
      if (response) {
        return {
          status: _api.requestStatus.success
        };
      }
      return {
        status: _api.requestStatus.fail,
        errors: result === null || result === void 0 ? void 0 : result.errors
      };
    }, token);
  });
  return function updateAppCompanyDetails(_x98, _x99) {
    return _ref28.apply(this, arguments);
  };
}();
var updateCDHCard = exports.updateCDHCard = function () {
  var _ref29 = (0, _asyncToGenerator2.default)(function* (token, data) {
    return yield (0, _gql.executeGraphQLMutation)((0, _api.updatePaymentCard)(), {
      companyId: data.companyId,
      cardId: data.cardId,
      cardLabel: data.cardLabel,
      cardType: data.cardType,
      cardNumber: data.cardNumber,
      expiryDate: data.expiryDate,
      cardHolderName: data.cardHolderName,
      cardToken: data.cardToken,
      billingAddress: data.billingAddress,
      cnpRequired: data.cnpRequired,
      cnpBusinessAccountPassword: data.memorableWord
    }, result => {
      var _result$data23;
      var response = result === null || result === void 0 || (_result$data23 = result.data) === null || _result$data23 === void 0 ? void 0 : _result$data23.updatePaymentCard;
      if (response === '{success=true}') {
        return {
          status: _api.requestStatus.success
        };
      }
      return {
        status: _api.requestStatus.fail,
        errors: result === null || result === void 0 ? void 0 : result.errors
      };
    }, token);
  });
  return function updateCDHCard(_x100, _x101) {
    return _ref29.apply(this, arguments);
  };
}();
var resendActivationEmail = exports.resendActivationEmail = function () {
  var _ref30 = (0, _asyncToGenerator2.default)(function* (email, companyName, language) {
    return yield (0, _gql.executeGraphQLMutation)((0, _api.resendActivationEmailQuery)(), {
      sendActivationRequest: {
        email,
        companyName,
        language
      }
    }, result => result.data.resendActivationEmail);
  });
  return function resendActivationEmail(_x102, _x103, _x104) {
    return _ref30.apply(this, arguments);
  };
}();
var InnBRegistrationStepOne = exports.InnBRegistrationStepOne = function () {
  var _ref31 = (0, _asyncToGenerator2.default)(function* (innBRegistrationStepOneRequest) {
    var response = yield (0, _gql.executeGraphQLMutation)((0, _api.InnBRegistrationStepOneQuery)(), {
      innBRegistrationStepOneRequest: _objectSpread({}, innBRegistrationStepOneRequest)
    }, result => {
      return result.data;
    });
    return response;
  });
  return function InnBRegistrationStepOne(_x105) {
    return _ref31.apply(this, arguments);
  };
}();
var updateMarketingPreferences = exports.updateMarketingPreferences = function () {
  var _ref32 = (0, _asyncToGenerator2.default)(function* (updateMarketingPreferencesRequest) {
    var response = yield (0, _gql.executeGraphQLMutation)(_api.REGISTER_USER_MARKETING, _objectSpread({}, updateMarketingPreferencesRequest), result => result, '');
    return response;
  });
  return function updateMarketingPreferences(_x106) {
    return _ref32.apply(this, arguments);
  };
}();
var registrationStepTwo = exports.registrationStepTwo = function () {
  var _ref33 = (0, _asyncToGenerator2.default)(function* (innBRegistrationStepTwoRequest) {
    return yield (0, _gql.executeGraphQLMutation)((0, _api.registrationStepTwoQuery)(), {
      innBRegistrationStepTwoRequest: _objectSpread({}, innBRegistrationStepTwoRequest)
    }, result => {
      var _result$data24;
      return result === null || result === void 0 || (_result$data24 = result.data) === null || _result$data24 === void 0 ? void 0 : _result$data24.innBRegistrationStepTwo;
    });
  });
  return function registrationStepTwo(_x107) {
    return _ref33.apply(this, arguments);
  };
}();
var authenticateRegistration = exports.authenticateRegistration = function () {
  var _ref34 = (0, _asyncToGenerator2.default)(function* (token, registrationCode) {
    var authenticationAnswers = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
    return yield (0, _gql.executeGraphQLMutation)((0, _api.authenticateRegistrationMutation)(), {
      registrationCode,
      authenticationAnswers
    }, result => result.data.authenticateRegistration, token);
  });
  return function authenticateRegistration(_x108, _x109) {
    return _ref34.apply(this, arguments);
  };
}();
var updateBookingAlerts = exports.updateBookingAlerts = function () {
  var _ref35 = (0, _asyncToGenerator2.default)(function* (companyId, bookingAlerts, token) {
    return yield (0, _gql.executeGraphQLMutation)(_api.updateBookingAlertsQuery, {
      companyId,
      bookingAlerts
    }, result => {
      var _result$data25;
      var genericError = {
        status: _api.requestStatus.fail,
        error: _api.requestErrors.generic
      };
      if (result !== null && result !== void 0 && result.errors && result.errors.length > 0) {
        return genericError;
      }
      if ((result === null || result === void 0 || (_result$data25 = result.data) === null || _result$data25 === void 0 ? void 0 : _result$data25.updateBookingAlerts) === '') {
        return {
          status: _api.requestStatus.success
        };
      }
      return genericError;
    }, token);
  });
  return function updateBookingAlerts(_x110, _x111, _x112) {
    return _ref35.apply(this, arguments);
  };
}();
var shareApplication = exports.shareApplication = function () {
  var _ref36 = (0, _asyncToGenerator2.default)(function* (applicationId, applicationGuid, employeeId, token, email, fullName) {
    if (!applicationId || !applicationGuid) {
      throw new Error('Application ID and GUID are required');
    }
    if (!email || !fullName) {
      throw new Error('Email and full name are required for sharing application');
    }
    var shareRequest = {
      shareApplicationRequest: {
        applicationId,
        applicationGuid,
        employeeId,
        email,
        fullName
      }
    };
    return yield (0, _gql.executeGraphQLMutation)(_api.SHARE_APPLICATION, shareRequest, result => {
      var _result$data26;
      return result === null || result === void 0 || (_result$data26 = result.data) === null || _result$data26 === void 0 ? void 0 : _result$data26.shareApplication;
    }, token);
  });
  return function shareApplication(_x113, _x114, _x115, _x116, _x117, _x118) {
    return _ref36.apply(this, arguments);
  };
}();
var removeParticipant = exports.removeParticipant = function () {
  var _ref37 = (0, _asyncToGenerator2.default)(function* (applicationId, applicationGuid, participantId, token) {
    var employeeId = typeof participantId === 'string' ? parseInt(participantId, 10) : participantId;
    return yield (0, _gql.executeGraphQLMutation)(_api.REMOVE_PARTICIPANT, {
      removeParticipantRequest: {
        applicationId,
        applicationGuid,
        employeeId
      }
    }, result => {
      var _result$data27;
      return result === null || result === void 0 || (_result$data27 = result.data) === null || _result$data27 === void 0 ? void 0 : _result$data27.removeParticipant;
    }, token);
  });
  return function removeParticipant(_x119, _x120, _x121, _x122) {
    return _ref37.apply(this, arguments);
  };
}();
var approveRejectEmployee = exports.approveRejectEmployee = function () {
  var _ref38 = (0, _asyncToGenerator2.default)(function* (approveRejectRequest, token) {
    return yield (0, _gql.executeGraphQLMutation)((0, _api.approveRejectEmployeeQuery)(), {
      approveRejectRequest
    }, result => {
      var _result$data28;
      var genericError = {
        status: _api.requestStatus.fail,
        error: _api.requestErrors.generic
      };
      if (result !== null && result !== void 0 && result.errors && result.errors.length > 0) {
        return genericError;
      }
      if ((result === null || result === void 0 || (_result$data28 = result.data) === null || _result$data28 === void 0 ? void 0 : _result$data28.approveRejectEmployee) === '') {
        return {
          status: _api.requestStatus.success
        };
      }
      return genericError;
    }, token);
  });
  return function approveRejectEmployee(_x123, _x124) {
    return _ref38.apply(this, arguments);
  };
}();
var submitRegistration = exports.submitRegistration = function () {
  var _ref39 = (0, _asyncToGenerator2.default)(function* (token, registrationCode, registrationDetails) {
    var authenticationAnswers = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
    return yield (0, _gql.executeGraphQLMutation)((0, _api.submitRegistrationMutation)(), {
      registrationSubmitRequest: {
        innBusiness: true,
        registrationCode,
        registrationDetails,
        authenticationAnswers
      }
    }, result => result.data.submitRegistration, token);
  });
  return function submitRegistration(_x125, _x126, _x127) {
    return _ref39.apply(this, arguments);
  };
}();
var forgotPassword = exports.forgotPassword = function () {
  var _ref40 = (0, _asyncToGenerator2.default)(function* (language, innBusiness, forgottenPasswordRequest) {
    return yield (0, _gql.executeGraphQLMutation)((0, _api.forgotPasswordQuery)(), {
      language,
      innBusiness,
      forgottenPasswordRequest
    }, result => result.data.forgotPassword);
  });
  return function forgotPassword(_x128, _x129, _x130) {
    return _ref40.apply(this, arguments);
  };
}();
var resetPassword = exports.resetPassword = function () {
  var _ref41 = (0, _asyncToGenerator2.default)(function* (passwordToken, resetPasswordRequest) {
    return yield (0, _gql.executeGraphQLMutation)((0, _api.resetPasswordQuery)(), {
      payload: resetPasswordRequest
    }, result => result.data.resetPassword.passwordChanged, undefined, {
      'password-token': passwordToken
    });
  });
  return function resetPassword(_x131, _x132) {
    return _ref41.apply(this, arguments);
  };
}();
var directDebit = exports.directDebit = function () {
  var _ref42 = (0, _asyncToGenerator2.default)(function* (token, applicationId, applicationGuid, directDebitOption, resumeUrl) {
    return yield (0, _gql.executeGraphQLMutation)((0, _api.directDebitMutation)(), {
      directDebitRequest: {
        applicationGuid,
        applicationId,
        directDebitOption,
        resumeUrl
      }
    }, result => {
      var _result$data29;
      var response = result === null || result === void 0 || (_result$data29 = result.data) === null || _result$data29 === void 0 ? void 0 : _result$data29.directDebit;
      if (response) {
        return {
          status: _api.requestStatus.success,
          data: response
        };
      }
      return {
        status: _api.requestStatus.fail,
        errors: result === null || result === void 0 ? void 0 : result.errors
      };
    }, token);
  });
  return function directDebit(_x133, _x134, _x135, _x136, _x137) {
    return _ref42.apply(this, arguments);
  };
}();
var validateResetKey = exports.validateResetKey = function () {
  var _ref43 = (0, _asyncToGenerator2.default)(function* (validateResetKeyRequest) {
    return yield (0, _gql.executeGraphQLMutation)((0, _api.validateResetKeyQuery)(), {
      validateResetKeyRequest
    }, result => result.data.validateResetKey, undefined);
  });
  return function validateResetKey(_x138) {
    return _ref43.apply(this, arguments);
  };
}();
var updateResumeUrl = exports.updateResumeUrl = function () {
  var _ref44 = (0, _asyncToGenerator2.default)(function* (token, applicationId, applicationGuid, resumeUrl) {
    return yield (0, _gql.executeGraphQLMutation)((0, _api.updateResumeUrlMutation)(), {
      updateResumeUrlRequest: {
        applicationId,
        applicationGuid,
        resumeUrl
      }
    }, result => result.data.updateResumeUrl, token);
  });
  return function updateResumeUrl(_x139, _x140, _x141, _x142) {
    return _ref44.apply(this, arguments);
  };
}();
var viewCustomerInvoices = exports.viewCustomerInvoices = function () {
  var _ref45 = (0, _asyncToGenerator2.default)(function* (token, tetheredUserGuid, schemeCustomerId, dateFrom, dateTo, page, maximumDisplayRows) {
    return yield (0, _gql.executeGraphQLMutation)((0, _api.viewCustomerInvoicesQuery)(), {
      payload: {
        tetheredUserGuid,
        schemeCustomerId,
        searchCriteria: {
          dateFrom,
          dateTo
        },
        pagingRequest: {
          page,
          maximumDisplayRows
        }
      }
    }, result => result.data.viewCustomerInvoicesV2, token);
  });
  return function viewCustomerInvoices(_x143, _x144, _x145, _x146, _x147, _x148, _x149) {
    return _ref45.apply(this, arguments);
  };
}();